<template>
  <div>
    <!-- <AprovalPMPopup
      :activate="active"
      @callback="callBackPopUp"
      @withClose="loadData"
      :passData="passData"
    /> -->
    <header class="w-full">
      <div class="mb-base mt-4 vx-row justify-between items-top">
        <section class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-start">
          <span class="text-black text-2xl">Tabel Donatur</span>
        </section>
        <!-- <section
            class="vx-col md:w-1/2 lg:w-1/2 xl:w-1/2 sm:w-full flex justify-end"
          >
            <vs-button @click="toAdd"
              >Tambah PM</vs-button
            >
          </section> -->
      </div>
      <div class="vx-row justify-between items-center">
        <!-- <section class="mb-base vx-col md:w-2/5 lg:w-2/5 xl:w-2/5 sm:w-full">
            <div class="w-full gap-2 flex justify-start items-center">
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <vs-button icon-after icon="expand_more">Aksi</vs-button> -->
        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
        <!-- <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="dialogDelete"
                  >
                    <span>Hapus</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
              <vs-dropdown vs-trigger-click class="cursor-pointer">
                <div
                  class="
                    p-4
                    border border-solid
                    d-theme-border-grey-light
                    rounded-full
                    d-theme-dark-bg
                    cursor-pointer
                    flex
                    items-center
                    justify-between
                    font-medium
                  "
                >
                  <span class="mr-2">{{ `entries ${limit}` }}</span>
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div> 
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    v-for="(item, index) in limitDataTables"
                    :key="index"
                    @click="limit = item"
                  >
                    <span>{{ item }}</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </section>
          <section class="mb-base vx-col md:w-3/5 lg:w-3/5 xl:w-3/5 sm:w-full">
            <div class="w-full flex justify-end gap-2 flex-wrap items-center">
              <vs-input v-model="search" placeholder="Search..." />
            </div>
          </section> -->
      </div>

      <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
      <div
        class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
      ></div>
    </header>

    <main ref="loadDonaturs">
      <vs-table stripe :data="donaturs" v-model="selected" :max-items="limit">
        <template slot="thead">
          <vs-th>Name</vs-th>
          <vs-th>Doa</vs-th>
          <vs-th>Transaksi</vs-th>
          <!-- <vs-th>Aksi</vs-th> -->
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td :data="data[indextr].doa">
              {{ data[indextr].doa !== null ? data[indextr].doa : "(Kosong)" }}
            </vs-td>
            <vs-td :data="data[indextr].pembayaran">
              {{
                data[indextr].pembayaran === null
                  ? "(Kosong)"
                  : data[indextr].pembayaran | toCurrency
              }}
            </vs-td>
            <vs-td>
              <div class="flex justify-start gap-2">
                <!-- <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click="openPopUp(data[indextr])"
                >
                </vs-button> -->
                <!-- <vs-button
                    color="warning"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-info"
                    @click="toDetail(data[indextr].id)"
                  >
                  </vs-button> -->
                <!-- <vs-button
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-trash"
                    @click="dialogDelete(data[indextr].id, data[indextr].name)"
                  >
                  </vs-button> -->
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </main>
    <footer>
      <div class="justify-end mt-2">
        <vs-pagination :total="totalPage" v-model="currentPg"></vs-pagination>
      </div>
    </footer>
  </div>
</template>

<script>
// import AprovalPMPopup from "@/views/campaign/component/AprovalPMPopup.vue";
import limitDataTables from "@/limitDataTable.js";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    // AprovalPMPopup,
  },
  props: {
    campaignDetail: { type: Object, default: {} },
  },
  data() {
    return {
      url,
      emptyImage,
      params: {},
      limitDataTables,
      limit: limitDataTables[0],
      active: false,
      activeSubmenu: false,
      passSubmenu: null,
      passData: null,
      pagination: {
        start: 0,
        length: limitDataTables[0],
      },
      currentPg: 1,
      selected: [],
      access: null,
      tableList: [
        "vs-th: Component",
        "vs-tr: Component",
        "vs-td: Component",
        "thread: Slot",
        "tbody: Slot",
        "header: Slot",
      ],
      donaturs: [],
      search: "",
    };
  },
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    getDetailUser(v) {
      return this.$store.getters["users/getDetail"](v);
    },
    totalPage() {
      let pages = this.donaturs.length / parseInt(this.limit);
      let number = Math.floor(pages);
      if (pages <= parseFloat(number)) {
        return number;
      }

      return number + 1;
    },
  },
  watch: {
    totalPage() {
      if (this.currentPg > this.totalPage) {
        this.currentPg = this.totalPage;
      }
    },
    limit() {
      this.pagination.length = parseInt(this.limit);
      this.getData();
    },
    currentPg() {
      this.pagination.start =
        this.currentPg <= 1
          ? 0
          : this.currentPg * parseInt(this.limit) - parseInt(this.limit);
      this.getData();
    },
  },
  methods: {
    loadData(val) {
      if (val) {
        this.getData();
      }
    },
    callBackPopUp(val) {
      this.active = val;
      this.passData = null;
    },
    openPopUp(item) {
      this.active = true;
      this.passData = item;
    },
    dialogDelete(id, name) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name && id ? `Hapus ${name} ?` : "Hapus Item Terpilih ?",
        text:
          name && id
            ? `Anda yakin ingin menghapus item ${name}`
            : "Anda yakin ingin menghapus item yang terpilih",
        accept: () => {
          if (name && id) {
            this.delete(id);
          } else {
            // eslint-disable-next-line no-lonely-if
            if (this.selected.length === 0) {
              this.$vs.notify({
                title: "Tidak ada item yang dipilih",
                text: "Pilihlah salah satu item atau semua item",
                color: "danger",
                position: "top-right",
              });
            } else {
              // eslint-disable-next-line prefer-const
              for (let i in this.selected) {
                this.delete(this.selected[i].id);
              }
            }
          }
        },
      });
    },
    delete(id) {
      this.$vs.loading({
        container: this.$refs.loadDonaturs,
        color: "primary",
      });
      const fungsi = {
        fungsi: 1,
      };
      this.$store
        .dispatch("penyaluran/cudTerimaManfaat", [Object.assign(fungsi, { id: id })])
        .then((v) => {
          // this.$vs.notify({
          //   position: "top-right",
          //   title: "Menghapus Sukses!",
          //   text: `Campaign ${v.name} Berhasil dihapus`,
          //   iconPack: "feather",
          //   icon: "icon-smile",
          //   color: "primary",
          // });
          this.$vs.notify({
            position: "top-right",
            title: "Menghapus Sukses!",
            text: `Penerima Manfaat Berhasil dihapus`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.getData();
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadDonaturs);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    getData() {
      this.$vs.loading({
        container: this.$refs.loadDonaturs,
        color: "primary",
      });
      this.$store
        .dispatch("campaign/getCampaign", {
          ...this.pagination,
          search: this.campaignDetail.name,
          filter: "name",
        })
        .then((v) => {
          this.$vs.loading.close(this.$refs.loadDonaturs);
          this.donaturs = v.data.length !== 0 ? v.data[0].donatur_doa : [];
        })
        .catch((e) => {
          this.$vs.loading.close(this.$refs.loadDonaturs);
          if (e.response) {
            console.error(e.response.data.message);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    // this.getKategori();
    // this.getSubKategori();
    // if (this.$store.state.auth.profileAccess !== null) {
    //   if (
    //     this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/campaign"
    //     )
    //   ) {
    //     this.access = this.$store.state.auth.profileAccess.menu.find(
    //       (e) => e.menu.url === "/dashboard/campaign"
    //     );
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.text-blue {
  color: blue;
}
img {
  max-height: 92px;
  max-width: 92px;
  overflow: auto;
}
</style>
